import { array, assign, object } from "superstruct";

import { CartSectionsSchema } from "../api_services/AjaxApiCartApiService/schemas/CartSectionsSchema";
import { DiscountCodesSchema } from "../api_services/AjaxApiCartApiService/schemas/DiscountCodesSchema";
import { CartSchema } from "./CartSchema";

export const UpdateCartSchema = assign(
    CartSchema,
    object({
        discount_codes: array(DiscountCodesSchema),
        sections: CartSectionsSchema,
    })
);
